/* eslint-disable no-case-declarations */
import { AxiosError } from 'axios';
import { memo, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { Subscription } from 'rxjs';
import { Routes } from 'src/routes/route';
import { useTaiKhoan } from 'src/stores';
import { HttpStatusCode, IBaseProps } from 'src/types/common.type';
import EventBus from 'src/utils/event-bus/event-bus';
import { EventBusName, IBaseEventPayload } from 'src/utils/event-bus/event-bus.types';
import MESSAGE from 'src/utils/message';

interface IProps extends IBaseProps {}

interface IErrorRes {
  error: string;
  message: string | string[];
  statusCode: HttpStatusCode;
}

function ErrorProvider(props: IProps) {
  const subscriptions = useRef<any>();
  const { clear } = useTaiKhoan();
  const navigate = useNavigate();
  // const { pathname } = useLocation();

  useEffect(() => {
    registerEventBus();

    return () => {
      unregisterEventBus();
    };
  }, []);

  const registerEventBus = () => {
    subscriptions.current = new Subscription();
    subscriptions.current.add(
      EventBus.getInstance().events.subscribe((data: IBaseEventPayload<AxiosError<any>>) => {
        switch (data.type) {
          case EventBusName.ERROR:
            const { response } = data.payload;
            const { data: res } = response as { status: HttpStatusCode; data: IErrorRes };

            if (res) {
              switch (res.statusCode) {
                case HttpStatusCode.BAD_REQUEST:
                  if (Array.isArray(res.message)) {
                    MESSAGE.error(res.message[0]);
                  } else {
                    MESSAGE.error(res.message);
                  }
                  break;
                case HttpStatusCode.UNAUTHORIZED:
                  MESSAGE.error('Thông tin đăng nhập không chính xác!');

                  clear();
                  navigate(Routes.LOGIN.path);
                  break;

                default:
                  break;
              }
            } else {
              MESSAGE.error('Hệ thống đang gặp sự cố, vui lòng thử lại!');
            }

            break;
          default:
            break;
        }
      }),
    );
  };

  const unregisterEventBus = () => {
    subscriptions.current?.unsubscribe();
  };

  return props.children;
}

export default memo(ErrorProvider);
